import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const CountUp = ({ value, duration = 1200, format = (v) => v.toFixed(2) }) => {
  const [v, setV] = useState(0);
  useEffect(() => {
    let raf;
    const start = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - start) / duration);
      setV(value * (1 - Math.pow(1 - p, 3)));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);
  return <>{format(v)}</>;
};

export const CoinRain = ({ count = 26 }) => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden z-30">
    {Array.from({ length: count }, (_, i) => (
      <motion.div key={i} initial={{ y: -60, x: `${Math.random() * 100}%`, rotateY: 0, opacity: 1 }}
        animate={{ y: 520, rotateY: 720, opacity: [1, 1, 0] }} transition={{ duration: 1.6 + Math.random(), delay: Math.random() * 0.8, ease: "easeIn" }}
        className="absolute w-7 h-7 rounded-full border-2 border-[#b8921f]"
        style={{ background: "radial-gradient(circle at 30% 30%, #fff3b0, #FFD700 40%, #a07c1c)" }} />
    ))}
  </div>
);
